import { Box } from '@mui/material';
import About from './About';
import ExternalLinksMenu from './ExternalLinksMenu';
import GlobalSettings from './GlobalSettings';

export default function ApplicationQuickMenu() {
    return (
        <Box display="flex" flexDirection="row">
            <GlobalSettings />
            <About />
            <ExternalLinksMenu />
        </Box>
    );
}
